import script from "./SmallFavourite.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmallFavourite.vue?vue&type=script&setup=true&lang=ts"

import "./SmallFavourite.vue?vue&type=style&index=0&id=2222fc00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2222fc00"]])

export default __exports__